
import MobileHeader from "components/mobile-header";
import PageHeader from "components/page-header";
import NotificationBar from "components/notification-bar";
import TutorialPage from "sections/tutorial-section/audio_check_tutorial";

const TutorialSection = () => {
  return (
    <div className="w-full px-4 md:px-6 lg:px-6">
      <MobileHeader />
      
      <PageHeader label="Tutorial">
        <NotificationBar />
      </PageHeader>


      <TutorialPage className="items-center justify-center xl:max-w-[850px]" />

    </div>
  );
};

export default TutorialSection;